export function sendRequest(method, data, endPoint) {

  return fetch(`${themeVars.root}api/${endPoint}`, {
    method: method,
    credentials: 'same-origin',
    body: data,
  })
    .then(res => res.json())
    .catch((err, res) => {
      console.error('request failed', err)
      return res
    })
}

export const updateURLparams = (data) => {
  let url = new URL(document.URL)
  let searchParams = url.searchParams
  Object.entries(data).forEach(([key, value]) => searchParams.set(key, value))
  url.search = searchParams.toString()
  window.history.pushState('', '', url.href)
}

export const delay = (ms) => new Promise((resolve) => setTimeout(() => resolve(), ms))

export function debounce(cb, delay = 1000) {
  let timeout

  return (...args) => {
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      cb(...args)
    }, delay)
  }
}

export function throttle(cb, delay = 1000) {
  let shouldWait = false
  let waitingArgs
  const timeoutFunc = () => {
    if (waitingArgs == null) {
      shouldWait = false
    } else {
      cb(...waitingArgs)
      waitingArgs = null
      setTimeout(timeoutFunc, delay)
    }
  }

  return (...args) => {
    if (shouldWait) {
      waitingArgs = args
      return
    }

    cb(...args)
    shouldWait = true

    setTimeout(timeoutFunc, delay)
  }
}

export async function toggleElement(el, show) {
  const {hidden, shown} = basicVars

  if (show) {
    el.classList.remove(hidden)
    await delay(100)
    el.classList.add(shown)
  } else {
    el.classList.remove(shown)
    await delay(300)
    el.classList.add(hidden)
  }
}

export function addGlobalEventListener(type, selector, callback, options, parent = document) {
  parent.addEventListener(type, e => {
    if (e.target.matches(selector)) callback(e)
  }, options)
}

export const qs = (selector, parent = document) => parent?.querySelector(selector)

export const qsa = (selector, parent = document) => [...parent?.querySelectorAll(selector)]

export const mapMarkers = {
  rehabCare: encodeURIComponent(`
  <svg class="marker" xmlns="http://www.w3.org/2000/svg" width="18" height="25" viewBox="0 0 364 496">
        <defs>
          <clipPath id="ldjda">
            <path
              d="M364 181.841c0 96.045-162.145 299.211-169.095 307.973A16.55 16.55 0 0 1 182 496a16.55 16.55 0 0 1-12.905-6.186C162.145 481.052 0 277.886 0 181.84 0 81.413 81.484 0 182 0s182 81.413 182 181.841zM182 231c36.45 0 66-29.55 66-66s-29.55-66-66-66-66 29.55-66 66 29.55 66 66 66z"/>
          </clipPath>
        </defs>
        <g>
          <g>
            <g>
              <g>
                <g/>
                <g clip-path="url(#ldjda)">
                  <path fill="#d3364a" d="M-243 0h850v496h-850z"/>
                </g>
                <g clip-path="url(#ldjda)" opacity=".49">
                  <g opacity=".39">
                    <path fill="#fff"
                          d="M-95.59 216.368c24.464 5.42 49.298 9 74.296 10.71 95.266 6.673 175.759-11.53 242.658-47.015a438.68 438.68 0 0 1-73.174-9.763C82.576 200.005 4.943 216.47-85.438 216.47c-3.41 0-6.778-.056-10.152-.102z"/>
                  </g>
                  <g opacity=".39">
                    <path fill="#fff"
                          d="M25.072 121.027C-102.096 44.204-182.218-97.18-216.423-245.35l-186.057 19.578c25.612 111.638 68.784 211.972 130.4 293.824 55.385 38.902 124.31 62.394 207.82 62.394a411.377 411.377 0 0 0 89.332-9.419z"/>
                  </g>
                  <g opacity=".39">
                    <path fill="#fff"
                          d="M712.148-343.089c-1.422 190.004-72.01 385.98-250.085 474.946-56.137 67.998-126.747 121.663-212.513 156.309a904.652 904.652 0 0 0 34.538-2.96c388.11-40.85 557.175-310.582 562.56-642.446z"/>
                  </g>
                  <g opacity=".24">
                    <path fill="#fff"
                          d="M-105.16 216.174C-412.99 207.926-567.684 6.18-599.727-257.429h145.797a758.48 758.48 0 0 1-1.474-21.807L-642.03-292.31C-625.033 39.17-446.406 302.858-54.493 330.3c117.026 8.196 218.137-7.428 304.045-42.13-140.976 9.321-258.846-17.637-354.712-71.996z"/>
                  </g>
                  <g opacity=".24">
                    <path fill="#fff"
                          d="M298.888 177.776c62.277-6.554 116.42-22.561 163.177-45.92 74.689-90.47 123.769-206.297 148.867-336.42l-134.917-9.446C446.403-52.904 365.4 103.652 221.36 180.057a500.866 500.866 0 0 0 77.528-2.28z"/>
                  </g>
                  <g opacity=".39">
                    <path fill="#fff"
                          d="M462.066 131.86c-46.757 23.36-100.9 39.367-163.177 45.921a500.866 500.866 0 0 1-77.528 2.281c-66.9 35.486-147.392 53.688-242.658 47.016a501.837 501.837 0 0 1-74.296-10.71 727.548 727.548 0 0 1-9.567-.194c95.867 54.358 213.737 81.317 354.712 71.995 85.767-34.646 156.377-88.31 212.514-156.309z"/>
                  </g>
                  <g opacity=".38">
                    <path fill="#fff"
                          d="M462.066 131.86c-46.757 23.36-100.9 39.367-163.177 45.921a500.866 500.866 0 0 1-77.528 2.281c-66.9 35.486-147.392 53.688-242.658 47.016a501.837 501.837 0 0 1-74.296-10.71 727.548 727.548 0 0 1-9.567-.194c95.867 54.358 213.737 81.317 354.712 71.995 85.767-34.646 156.377-88.31 212.514-156.309z"/>
                  </g>
                  <g opacity=".12">
                    <path fill="#fff"
                          d="M426.433-257.43H315.93C296.87-88.018 209.421 80.122 25.07 121.026a407.619 407.619 0 0 0 123.115 49.273C314.037 95.213 403.021-64.551 426.433-257.43z"/>
                  </g>
                  <g opacity=".12">
                    <path fill="#fff"
                          d="M-111.385 212.587c-63.203-36.99-116.66-86.041-160.695-144.537C-375.085-4.3-431.208-130.012-446.873-257.43h-7.057c17.038 207.582 121.73 412.533 342.545 470.017z"/>
                  </g>
                  <g opacity=".39">
                    <path fill="#fff"
                          d="M-111.385 212.587c5.192 1.351 10.47 2.593 15.792 3.78 3.374.046 6.74.101 10.152.101 90.38 0 168.014-16.464 233.628-46.17a407.62 407.62 0 0 1-123.115-49.272 411.377 411.377 0 0 1-89.332 9.418c-83.51 0-152.435-23.491-207.82-62.394 44.034 58.496 97.492 107.547 160.695 144.537z"/>
                  </g>
                  <g opacity=".38">
                    <path fill="#fff"
                          d="M-111.385 212.587c5.192 1.351 10.47 2.593 15.792 3.78 3.374.046 6.74.101 10.152.101 90.38 0 168.014-16.464 233.628-46.17a407.62 407.62 0 0 1-123.115-49.272 411.377 411.377 0 0 1-89.332 9.418c-83.51 0-152.435-23.491-207.82-62.394 44.034 58.496 97.492 107.547 160.695 144.537z"/>
                  </g>
                  <g opacity=".24">
                    <path fill="#fff"
                          d="M-105.154 216.174a516.704 516.704 0 0 1-6.225-3.587C-332.192 155.103-436.885-49.848-453.923-257.43H-599.72c32.043 263.61 186.736 465.355 494.566 473.604z"/>
                  </g>
                  <g opacity=".12">
                    <path fill="#fff"
                          d="M-105.154 216.174a516.704 516.704 0 0 1-6.225-3.587C-332.192 155.103-436.885-49.848-453.923-257.43H-599.72c32.043 263.61 186.736 465.355 494.566 473.604z"/>
                  </g>
                  <g opacity=".39">
                    <path fill="#fff"
                          d="M-105.155 216.177c3.173.085 6.362.15 9.567.193-5.321-1.187-10.6-2.428-15.792-3.78a531.576 531.576 0 0 0 6.225 3.587z"/>
                  </g>
                  <g opacity=".24">
                    <path fill="#fff"
                          d="M-105.155 216.177c3.173.085 6.362.15 9.567.193-5.321-1.187-10.6-2.428-15.792-3.78a531.576 531.576 0 0 0 6.225 3.587z"/>
                  </g>
                  <g opacity=".12">
                    <path fill="#fff"
                          d="M-105.155 216.177c3.173.085 6.362.15 9.567.193-5.321-1.187-10.6-2.428-15.792-3.78a531.576 531.576 0 0 0 6.225 3.587z"/>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
`),
  enterprises: encodeURIComponent(`
  <svg class="marker" xmlns="http://www.w3.org/2000/svg" width="18" height="25" viewBox="0 0 364 496">
        <defs>
          <clipPath id="ldjda">
            <path
              d="M364 181.841c0 96.045-162.145 299.211-169.095 307.973A16.55 16.55 0 0 1 182 496a16.55 16.55 0 0 1-12.905-6.186C162.145 481.052 0 277.886 0 181.84 0 81.413 81.484 0 182 0s182 81.413 182 181.841zM182 231c36.45 0 66-29.55 66-66s-29.55-66-66-66-66 29.55-66 66 29.55 66 66 66z"/>
          </clipPath>
        </defs>
        <g>
          <g>
            <g>
              <g>
                <g/>
                <g clip-path="url(#ldjda)">
                  <path fill="#019467" d="M-243 0h850v496h-850z"/>
                </g>
                <g clip-path="url(#ldjda)" opacity=".49">
                  <g opacity=".39">
                    <path fill="#fff"
                          d="M-95.59 216.368c24.464 5.42 49.298 9 74.296 10.71 95.266 6.673 175.759-11.53 242.658-47.015a438.68 438.68 0 0 1-73.174-9.763C82.576 200.005 4.943 216.47-85.438 216.47c-3.41 0-6.778-.056-10.152-.102z"/>
                  </g>
                  <g opacity=".39">
                    <path fill="#fff"
                          d="M25.072 121.027C-102.096 44.204-182.218-97.18-216.423-245.35l-186.057 19.578c25.612 111.638 68.784 211.972 130.4 293.824 55.385 38.902 124.31 62.394 207.82 62.394a411.377 411.377 0 0 0 89.332-9.419z"/>
                  </g>
                  <g opacity=".39">
                    <path fill="#fff"
                          d="M712.148-343.089c-1.422 190.004-72.01 385.98-250.085 474.946-56.137 67.998-126.747 121.663-212.513 156.309a904.652 904.652 0 0 0 34.538-2.96c388.11-40.85 557.175-310.582 562.56-642.446z"/>
                  </g>
                  <g opacity=".24">
                    <path fill="#fff"
                          d="M-105.16 216.174C-412.99 207.926-567.684 6.18-599.727-257.429h145.797a758.48 758.48 0 0 1-1.474-21.807L-642.03-292.31C-625.033 39.17-446.406 302.858-54.493 330.3c117.026 8.196 218.137-7.428 304.045-42.13-140.976 9.321-258.846-17.637-354.712-71.996z"/>
                  </g>
                  <g opacity=".24">
                    <path fill="#fff"
                          d="M298.888 177.776c62.277-6.554 116.42-22.561 163.177-45.92 74.689-90.47 123.769-206.297 148.867-336.42l-134.917-9.446C446.403-52.904 365.4 103.652 221.36 180.057a500.866 500.866 0 0 0 77.528-2.28z"/>
                  </g>
                  <g opacity=".39">
                    <path fill="#fff"
                          d="M462.066 131.86c-46.757 23.36-100.9 39.367-163.177 45.921a500.866 500.866 0 0 1-77.528 2.281c-66.9 35.486-147.392 53.688-242.658 47.016a501.837 501.837 0 0 1-74.296-10.71 727.548 727.548 0 0 1-9.567-.194c95.867 54.358 213.737 81.317 354.712 71.995 85.767-34.646 156.377-88.31 212.514-156.309z"/>
                  </g>
                  <g opacity=".38">
                    <path fill="#fff"
                          d="M462.066 131.86c-46.757 23.36-100.9 39.367-163.177 45.921a500.866 500.866 0 0 1-77.528 2.281c-66.9 35.486-147.392 53.688-242.658 47.016a501.837 501.837 0 0 1-74.296-10.71 727.548 727.548 0 0 1-9.567-.194c95.867 54.358 213.737 81.317 354.712 71.995 85.767-34.646 156.377-88.31 212.514-156.309z"/>
                  </g>
                  <g opacity=".12">
                    <path fill="#fff"
                          d="M426.433-257.43H315.93C296.87-88.018 209.421 80.122 25.07 121.026a407.619 407.619 0 0 0 123.115 49.273C314.037 95.213 403.021-64.551 426.433-257.43z"/>
                  </g>
                  <g opacity=".12">
                    <path fill="#fff"
                          d="M-111.385 212.587c-63.203-36.99-116.66-86.041-160.695-144.537C-375.085-4.3-431.208-130.012-446.873-257.43h-7.057c17.038 207.582 121.73 412.533 342.545 470.017z"/>
                  </g>
                  <g opacity=".39">
                    <path fill="#fff"
                          d="M-111.385 212.587c5.192 1.351 10.47 2.593 15.792 3.78 3.374.046 6.74.101 10.152.101 90.38 0 168.014-16.464 233.628-46.17a407.62 407.62 0 0 1-123.115-49.272 411.377 411.377 0 0 1-89.332 9.418c-83.51 0-152.435-23.491-207.82-62.394 44.034 58.496 97.492 107.547 160.695 144.537z"/>
                  </g>
                  <g opacity=".38">
                    <path fill="#fff"
                          d="M-111.385 212.587c5.192 1.351 10.47 2.593 15.792 3.78 3.374.046 6.74.101 10.152.101 90.38 0 168.014-16.464 233.628-46.17a407.62 407.62 0 0 1-123.115-49.272 411.377 411.377 0 0 1-89.332 9.418c-83.51 0-152.435-23.491-207.82-62.394 44.034 58.496 97.492 107.547 160.695 144.537z"/>
                  </g>
                  <g opacity=".24">
                    <path fill="#fff"
                          d="M-105.154 216.174a516.704 516.704 0 0 1-6.225-3.587C-332.192 155.103-436.885-49.848-453.923-257.43H-599.72c32.043 263.61 186.736 465.355 494.566 473.604z"/>
                  </g>
                  <g opacity=".12">
                    <path fill="#fff"
                          d="M-105.154 216.174a516.704 516.704 0 0 1-6.225-3.587C-332.192 155.103-436.885-49.848-453.923-257.43H-599.72c32.043 263.61 186.736 465.355 494.566 473.604z"/>
                  </g>
                  <g opacity=".39">
                    <path fill="#fff"
                          d="M-105.155 216.177c3.173.085 6.362.15 9.567.193-5.321-1.187-10.6-2.428-15.792-3.78a531.576 531.576 0 0 0 6.225 3.587z"/>
                  </g>
                  <g opacity=".24">
                    <path fill="#fff"
                          d="M-105.155 216.177c3.173.085 6.362.15 9.567.193-5.321-1.187-10.6-2.428-15.792-3.78a531.576 531.576 0 0 0 6.225 3.587z"/>
                  </g>
                  <g opacity=".12">
                    <path fill="#fff"
                          d="M-105.155 216.177c3.173.085 6.362.15 9.567.193-5.321-1.187-10.6-2.428-15.792-3.78a531.576 531.576 0 0 0 6.225 3.587z"/>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
`),
  nln: encodeURIComponent(`
  <svg class="marker" xmlns="http://www.w3.org/2000/svg" width="18" height="25" viewBox="0 0 364 496">
        <defs>
          <clipPath id="ldjda">
            <path
              d="M364 181.841c0 96.045-162.145 299.211-169.095 307.973A16.55 16.55 0 0 1 182 496a16.55 16.55 0 0 1-12.905-6.186C162.145 481.052 0 277.886 0 181.84 0 81.413 81.484 0 182 0s182 81.413 182 181.841zM182 231c36.45 0 66-29.55 66-66s-29.55-66-66-66-66 29.55-66 66 29.55 66 66 66z"/>
          </clipPath>
        </defs>
        <g>
          <g>
            <g>
              <g>
                <g/>
                <g clip-path="url(#ldjda)">
                  <path fill="#9a4c97 " d="M-243 0h850v496h-850z"/>
                </g>
                <g clip-path="url(#ldjda)" opacity=".49">
                  <g opacity=".39">
                    <path fill="#fff"
                          d="M-95.59 216.368c24.464 5.42 49.298 9 74.296 10.71 95.266 6.673 175.759-11.53 242.658-47.015a438.68 438.68 0 0 1-73.174-9.763C82.576 200.005 4.943 216.47-85.438 216.47c-3.41 0-6.778-.056-10.152-.102z"/>
                  </g>
                  <g opacity=".39">
                    <path fill="#fff"
                          d="M25.072 121.027C-102.096 44.204-182.218-97.18-216.423-245.35l-186.057 19.578c25.612 111.638 68.784 211.972 130.4 293.824 55.385 38.902 124.31 62.394 207.82 62.394a411.377 411.377 0 0 0 89.332-9.419z"/>
                  </g>
                  <g opacity=".39">
                    <path fill="#fff"
                          d="M712.148-343.089c-1.422 190.004-72.01 385.98-250.085 474.946-56.137 67.998-126.747 121.663-212.513 156.309a904.652 904.652 0 0 0 34.538-2.96c388.11-40.85 557.175-310.582 562.56-642.446z"/>
                  </g>
                  <g opacity=".24">
                    <path fill="#fff"
                          d="M-105.16 216.174C-412.99 207.926-567.684 6.18-599.727-257.429h145.797a758.48 758.48 0 0 1-1.474-21.807L-642.03-292.31C-625.033 39.17-446.406 302.858-54.493 330.3c117.026 8.196 218.137-7.428 304.045-42.13-140.976 9.321-258.846-17.637-354.712-71.996z"/>
                  </g>
                  <g opacity=".24">
                    <path fill="#fff"
                          d="M298.888 177.776c62.277-6.554 116.42-22.561 163.177-45.92 74.689-90.47 123.769-206.297 148.867-336.42l-134.917-9.446C446.403-52.904 365.4 103.652 221.36 180.057a500.866 500.866 0 0 0 77.528-2.28z"/>
                  </g>
                  <g opacity=".39">
                    <path fill="#fff"
                          d="M462.066 131.86c-46.757 23.36-100.9 39.367-163.177 45.921a500.866 500.866 0 0 1-77.528 2.281c-66.9 35.486-147.392 53.688-242.658 47.016a501.837 501.837 0 0 1-74.296-10.71 727.548 727.548 0 0 1-9.567-.194c95.867 54.358 213.737 81.317 354.712 71.995 85.767-34.646 156.377-88.31 212.514-156.309z"/>
                  </g>
                  <g opacity=".38">
                    <path fill="#fff"
                          d="M462.066 131.86c-46.757 23.36-100.9 39.367-163.177 45.921a500.866 500.866 0 0 1-77.528 2.281c-66.9 35.486-147.392 53.688-242.658 47.016a501.837 501.837 0 0 1-74.296-10.71 727.548 727.548 0 0 1-9.567-.194c95.867 54.358 213.737 81.317 354.712 71.995 85.767-34.646 156.377-88.31 212.514-156.309z"/>
                  </g>
                  <g opacity=".12">
                    <path fill="#fff"
                          d="M426.433-257.43H315.93C296.87-88.018 209.421 80.122 25.07 121.026a407.619 407.619 0 0 0 123.115 49.273C314.037 95.213 403.021-64.551 426.433-257.43z"/>
                  </g>
                  <g opacity=".12">
                    <path fill="#fff"
                          d="M-111.385 212.587c-63.203-36.99-116.66-86.041-160.695-144.537C-375.085-4.3-431.208-130.012-446.873-257.43h-7.057c17.038 207.582 121.73 412.533 342.545 470.017z"/>
                  </g>
                  <g opacity=".39">
                    <path fill="#fff"
                          d="M-111.385 212.587c5.192 1.351 10.47 2.593 15.792 3.78 3.374.046 6.74.101 10.152.101 90.38 0 168.014-16.464 233.628-46.17a407.62 407.62 0 0 1-123.115-49.272 411.377 411.377 0 0 1-89.332 9.418c-83.51 0-152.435-23.491-207.82-62.394 44.034 58.496 97.492 107.547 160.695 144.537z"/>
                  </g>
                  <g opacity=".38">
                    <path fill="#fff"
                          d="M-111.385 212.587c5.192 1.351 10.47 2.593 15.792 3.78 3.374.046 6.74.101 10.152.101 90.38 0 168.014-16.464 233.628-46.17a407.62 407.62 0 0 1-123.115-49.272 411.377 411.377 0 0 1-89.332 9.418c-83.51 0-152.435-23.491-207.82-62.394 44.034 58.496 97.492 107.547 160.695 144.537z"/>
                  </g>
                  <g opacity=".24">
                    <path fill="#fff"
                          d="M-105.154 216.174a516.704 516.704 0 0 1-6.225-3.587C-332.192 155.103-436.885-49.848-453.923-257.43H-599.72c32.043 263.61 186.736 465.355 494.566 473.604z"/>
                  </g>
                  <g opacity=".12">
                    <path fill="#fff"
                          d="M-105.154 216.174a516.704 516.704 0 0 1-6.225-3.587C-332.192 155.103-436.885-49.848-453.923-257.43H-599.72c32.043 263.61 186.736 465.355 494.566 473.604z"/>
                  </g>
                  <g opacity=".39">
                    <path fill="#fff"
                          d="M-105.155 216.177c3.173.085 6.362.15 9.567.193-5.321-1.187-10.6-2.428-15.792-3.78a531.576 531.576 0 0 0 6.225 3.587z"/>
                  </g>
                  <g opacity=".24">
                    <path fill="#fff"
                          d="M-105.155 216.177c3.173.085 6.362.15 9.567.193-5.321-1.187-10.6-2.428-15.792-3.78a531.576 531.576 0 0 0 6.225 3.587z"/>
                  </g>
                  <g opacity=".12">
                    <path fill="#fff"
                          d="M-105.155 216.177c3.173.085 6.362.15 9.567.193-5.321-1.187-10.6-2.428-15.792-3.78a531.576 531.576 0 0 0 6.225 3.587z"/>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
`),
  cluster: window.btoa(`
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="35" viewBox="0 0 36 35"><g><g><g><path fill="#d3364a" d="M17.998 10.06c-4.351 0-7.878 3.505-7.878 7.83 0 4.324 3.527 7.83 7.878 7.83 4.35 0 7.877-3.506 7.877-7.83 0-4.325-3.527-7.83-7.877-7.83"/></g><g opacity=".3"><path fill="#d3364a" d="M33.877 14.154c.285 1.198.436 2.448.436 3.731 0 7.295-4.873 13.48-11.553 15.509l.5 1.602C30.627 32.754 36 25.932 36 17.886c0-1.416-.167-2.794-.481-4.116z"/></g><g opacity=".3"><path fill="#d3364a" d="M1.687 17.887c0-1.225.138-2.418.399-3.566L.44 13.95A17.777 17.777 0 0 0 0 17.887c0 8.045 5.371 14.866 12.736 17.109l.487-1.606C6.55 31.356 1.687 25.176 1.687 17.887"/></g><g opacity=".3"><path fill="#d3364a" d="M17.997 1.677c4.249 0 8.123 1.623 11.029 4.277l1.145-1.23A17.992 17.992 0 0 0 17.997 0C13.212 0 8.857 1.866 5.63 4.904l1.155 1.22a16.308 16.308 0 0 1 11.212-4.447"/></g><g opacity=".55"><path fill="#d3364a" d="M30.939 17.887c0 5.792-3.873 10.7-9.179 12.306l.5 1.601c5.993-1.817 10.366-7.363 10.366-13.907 0-1.151-.136-2.272-.392-3.347l-1.642.384c.226.952.347 1.944.347 2.963"/></g><g opacity=".55"><path fill="#d3364a" d="M7.95 7.36l1.157 1.219a12.935 12.935 0 0 1 8.896-3.552 12.933 12.933 0 0 1 8.744 3.369l1.143-1.232A14.62 14.62 0 0 0 18 3.35 14.622 14.622 0 0 0 7.95 7.36"/></g><g opacity=".55"><path fill="#d3364a" d="M5.057 17.886c0-.97.11-1.916.315-2.825l-1.645-.371a14.447 14.447 0 0 0-.357 3.196c0 6.532 4.357 12.07 10.335 13.898l.486-1.606c-5.283-1.619-9.134-6.517-9.134-12.292"/></g><g opacity=".75"><path fill="#d3364a" d="M14.684 28.581l.486-1.605c-3.896-1.203-6.733-4.819-6.733-9.081 0-.716.08-1.413.232-2.084l-1.645-.371c-.179.79-.274 1.612-.274 2.455 0 5.019 3.344 9.276 7.934 10.686"/></g><g opacity=".75"><path fill="#d3364a" d="M27.564 17.89c0 4.288-2.872 7.921-6.804 9.101l.5 1.602c4.62-1.393 7.991-5.664 7.991-10.704 0-.887-.105-1.75-.302-2.579l-1.642.384a9.44 9.44 0 0 1 .257 2.195"/></g><g opacity=".75"><path fill="#d3364a" d="M17.997 8.387a9.56 9.56 0 0 1 6.448 2.491l1.145-1.23a11.247 11.247 0 0 0-7.593-2.938c-3 0-5.728 1.172-7.747 3.08l1.155 1.22a9.562 9.562 0 0 1 6.592-2.623"/></g></g></g></svg>
  `),
};

export const basicVars = {
  body: document.querySelector('body'),
  hidden: 'hidden',
  shown: 'shown',
}
